import ffmpeg from "./ffmpegInstance";
import { fetchFile } from "@ffmpeg/util";
import { fileToBase64 } from "./formats";

const coreURL = "https://unpkg.com/@ffmpeg/core@0.12.10/dist/esm/ffmpeg-core.js";
const wasmURL = "https://unpkg.com/@ffmpeg/core@0.12.10/dist/esm/ffmpeg-core.wasm";

export const compressVideo = async (file) => {
	if (!file) return null;
	await ffmpeg.load({ coreURL, wasmURL });

	const inputData = await fetchFile(file);
	ffmpeg.writeFile("input.mp4", inputData);

	await ffmpeg.exec([
		"-i",
		"input.mp4",
		"-vcodec",
		"libx264",
		"-acodec",
		"aac",
		"-b:v",
		"400k",
		"-b:a",
		"48k",
		"-vf",
		"scale=360:-2",
		"-preset",
		"ultrafast",
		"-movflags",
		"+faststart",
		"output.mp4",
	]);

	const data = await ffmpeg.readFile("input.mp4");

	const blob = new Blob([data], { type: "video/mp4" });
	const base64 = await fileToBase64(blob);
	return base64;
};

export const audioCompress = async (file) => {
	if (!file) return null;
	await ffmpeg.load({ coreURL, wasmURL });

	const inputData = await fetchFile(file);
	ffmpeg.writeFile("input.mp4", inputData);

	await ffmpeg.exec(["-i", "input.mp4", "-vcodec", "libx264", "-crf", "28", "-preset", "fast", "-vf", "scale=720:-1", "output.mp4"]);

	const data = await ffmpeg.readFile("input.mp4");

	const blob = new Blob([data], { type: "video/mp4" });
	const base64 = await fileToBase64(blob);
	return base64;
};
